// extracted by mini-css-extract-plugin
module.exports = {"HeroControls":"az_uuc","Counter":"az_vuc","PauseButton":"az_wuc","Light":"az_xuc","Dark":"az_yuc"};